// import "../../node_modules/gulp-sourcemaps/index";
// import '../../../../vendor/silverstripe/admin/client/dist/tinymce/tinymce.js';

// import tinymce from "gulp-sourcemaps";

function checkLength(obj, len) {
    if (obj.value.length > len) {
        obj.value = obj.value.substring(0, len)
    }
}

$(document).ready(function () {
    $('table.sortable').tablesorter({
        widgets: ["saveSort"],
    });

    if ($('#tiny').length) {
        tMCEInit();
    }

    function tMCEInit(content) {
        content = content || '';

        tinymce.init({
            selector: 'textarea#tiny',
            skin: 'silverstripe',
            height: 500,
            menubar: false,
            plugins: [
                'advlist', 'autolink',
                'lists', 'link', 'image', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks',
                'fullscreen', 'insertdatetime', 'media', 'table', 'help', 'wordcount'
            ],
            toolbar: 'undo redo | a11ycheck casechange blocks | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist checklist outdent indent | removeformat | code table help',

            setup: (editor) => {
                $('.insert-description').click(function () {
                    let target = $('.description-target');
                    let text = '';
                    let userFN = '';
                    let userEmail = '';
                    let userMobile = '';
                    let mat_num = $('.buttons').children('.mat_num').val();
                    let job_complete = $('#job-complete:checked').val();

                    $.ajax({
                        url: "/getUserEmailDetails",
                        method: 'POST',
                        dataType: 'json',
                        complete: function (response) {
                            userFN = response['FirstN'];
                            userEmail = response['Email'];
                            userMobile = response['Mobile'];

                            $('.tohtml div').each(function () {
                                let currentText = target.val();
                                if ($(this).hasClass('maintenance-request-status')) {
                                    // var text = 'Status:\r\n\t';
                                    // let targetStatus = $(this).find('option:selected').text();
                                    // text += targetStatus + '\r\n';
                                    return (currentText !== "something");
                                } else if ($(this).hasClass('maintenance-request-address')) {
                                    let address = $(this).children('dd').text();
                                    let hyperText = address.replaceAll(',', '').replaceAll(' ', '+');
                                    text += '<p><strong>' + $(this).children('dt').text() + '</strong><br>';
                                    text += '<a target="_blank" href="https://www.google.com/maps/place/' + hyperText + '/">' + address + '</a></p>';
                                } else {
                                    text += '<p><strong>' + $(this).children('dt').text() + '</strong><br>' + $(this).children('dd').text() + '</p>';
                                }
                            });

                            if ($('#addDeetsCheckbox').is(':checked')) {
                                text += '<p><strong>Staff who sent this:</strong><br>' + userFN + '</p>';
                                text += '<p><strong>Staff contact email:</strong><br>' + userEmail + '</p>';
                                text += '<p><strong>Staff contact number:</strong><br>' + userMobile + '</p>';
                            }

                            if ($('#job-complete').is(':checked')) {
                                text = '<p><a target="_blank" href="[completeURL]">Please click here when done to complete job.</a></p>' + text;
                            }

                            editor.setContent(text);
                        }
                    });
                });
            },
        });
    }

    $('#job_finish_form').submit(function (e) {
        let mco_num = $(this).children('.mco_num').val();

        $.ajax({
            url: '/closeJob',
            method: 'POST',
            data: {mco_num: mco_num},
            dataType: 'json',
            success: function (data) {

            }
        });
    });

    $('.update-propertyunits').change(function () {
        var prp_num = $(this).val();
        let select = $('#pru_num');

        $.ajax({
            url: "/getPropertyUnits",
            method: 'post',
            data: {prp_num: prp_num},
            dataType: 'json',
            complete: function (data) {
                var json = data.responseJSON;
                select.empty();
                $.each(json, function (i, value) {
                    select.append($('<option>').text(value.pru_name).attr('value', value.pru_num));
                });
                select.append($('<option>').text("Unit not listed").attr('value', '0'));
                populateTenantDetails('yes');
            }
        });
    });

    $('#pru_num').change(function () {
        if ($(this).val() > 0) {
            populateTenantDetails('yes');
        } else {
            let tenantName = $('#mat_contactname');
            let tenantPhone = $('#mat_contactphone');
            let tenantEmail = $('#mat_contactemail');

            tenantName.val('');
            tenantPhone.val('');
            tenantEmail.val('');
        }
    });

    $('#contact_details').change(function () {
        populateTenantDetails();
    });

    function populateTenantDetails(changePruNum) {
        let pru_num = $('#pru_num').val();
        let tenantName = $('#mat_contactname');
        let tenantPhone = $('#mat_contactphone');
        let tenantEmail = $('#mat_contactemail');

        $.ajax({
            url: "/getUnitTenantsDetails",
            method: 'post',
            data: {pru_num: pru_num},
            dataType: 'json',
            complete: function (data) {
                let json = data.responseJSON;

                let selectTarget = $('#contact_details');
                let contacts = json[0];

                if (typeof changePruNum !== 'undefined') {
                    selectTarget.empty();
                    selectTarget.append('<option value="' + contacts['pru_contactee'] + '">Head Contactee - ' + contacts['pru_contactee'] + '</option>');
                    selectTarget.append('<option value="' + contacts['pru_onsitecontactee'] + '">On-Site Contactee - ' + contacts['pru_onsitecontactee'] + '</option>');
                    selectTarget.append('<option value="new">Someone new</option>');
                }

                if (selectTarget.val() === contacts['pru_contactee']) {
                    tenantName.val(json[0].pru_contactee);
                    tenantPhone.val(json[0].pru_contactmobile);
                    tenantEmail.val(json[0].pru_contactemail);
                } else if (selectTarget.val() === contacts['pru_onsitecontactee']) {
                    tenantName.val(json[0].pru_onsitecontactee);
                    tenantPhone.val(json[0].pru_onsitemobile);
                    tenantEmail.val(json[0].pru_onsiteemail);
                } else {
                    tenantName.val('');
                    tenantPhone.val('');
                    tenantEmail.val('');
                }
            }
        });
    }

    $('.contractor-notes .toggle-more').click(function (event) {
        $(this).closest('section').find('.entry').fadeIn();
        $(this).fadeOut();
        event.preventDefault();
    });

    // if($('body.Contact-Us').length){
    // 	var myLatlng = new google.maps.LatLng('-45.882098033904434', '170.50184600775754');
    // 	var myOptions = {
    // 		zoom: 16,
    // 		center: myLatlng,
    // 		mapTypeId: google.maps.MapTypeId.ROADMAP
    // 	}
    // 	var map = new google.maps.Map(document.getElementById("map_canvas"), myOptions);
    // 	var marker = new google.maps.Marker({
    // 		position: myLatlng,
    // 		map: map,
    // 		title:"Oakwood Properties"
    // 	});
    //
    // 	var map = new google.maps.Map(document.getElementById("map_canvas2"), myOptions);
    // 	var marker = new google.maps.Marker({
    // 		position: myLatlng,
    // 		map: map,
    // 		title:"Oakwood Properties"
    // 	});
    // }

    var loading = false;
    $('.check-site').keyup(function (event) {
        let input = $(this);
        let code = $(this).val();
        let target = $(this).siblings('.unit-num');
        let spinner = $(this).siblings('.spinner');
        let select = target.find('select#pru_num');

        if (code.length === 7) {
            input.attr('disabled', true);

            spinner.fadeIn();
            $.ajax({
                url: "/checksitecode",
                method: 'post',
                data: {code: code},
                dataType: 'json',
                complete: function (data) {
                    // var decoded = JSON.parse(data);
                    // console.log(data);
                    let json = data.responseJSON;
                    // console.log(json);
                    select.empty();
                    $.each(json, function (i, value) {
                        select.append($('<option>').text(value.pru_name).attr('value', value.pru_num));
                    });
                    select.append($('<option>').text("Unit not listed").attr('value', '0'));
                    spinner.fadeOut('400', function () {
                        target.fadeIn();
                        input.attr('disabled', false);
                    });
                }
            });
        } else {
            target.fadeOut();
            select.find('select').val("-1"); // stops people trying to muck with it
        }

        event.preventDefault();
        event.stopPropagation();
    });

    if ($('#park-map').length) {
        makeParkMap();
    }
});

var map;

function makeParkMap() {
    let $lat = $('#prk_lat').val();
    let $long = $('#prk_long').val();
    let $address = $('#prk_address').val();

    map = L.map('park-map').setView([$lat, $long], 15)

    let ch = '';
    let marker = L.marker([$lat, $long]).addTo(map)
        .bindPopup('<span class="sub-heading">' + $address + '</span>');
    marker.ch = ch;

    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);

    let $southWest = L.latLng(-52.02545860348813, 158.0712890625),
        $northEast = L.latLng(-30.939924331023455, 189.44824218750003);

    let $bounds = L.latLngBounds($southWest, $northEast);

    map.setMaxBounds($bounds);
    map.setMinZoom(5);
}

if ($('.edit-form').length) {
// Function to handle form submissions
    function submitForm(action, target) {
        if (action === 'save') {
            target.children('.hidden-submit').val("1");
        } else {
            target.children('.hidden-submit').val("2");
            target.parent().submit();
        }

        if (!target.parent().find('.error')) {
            target.parent().submit(); // Submit the form
        }
    }

    $('.save-btn').on('click', function () {
        submitForm('save', $(this).parent());
    });

    $('.cancel-btn').on('click', function (e) {
        // console.log('hi3')
        // if (e.key !== 'Enter') {
        //     console.log('hi4')
        submitForm('cancel', $(this).parent());
        // }
    });

    $('.edit-form').keypress(function (e) {
        if (e.key === 'Enter') {
            e.preventDefault()
            // let target = $(this).children('.buttons');
            // submitForm('save', target); // Submit form on Enter key press
        }
    });
}

var pageLoaded = function () {

    // $(".inline-cbox").colorbox({transition: "fade", inline: true, width: "400px"});
    // $(".inline-cbox-large").colorbox({transition: "fade", inline: true, width: "800px"});
    // $(".iframe-cbox").colorbox({transition: "fade", iframe: true, width: "500px", height: "468px"});
    // $(".iframe-cbox-large").colorbox({transition: "fade", iframe: true, width: "800px", height: "468px"});


    var $submitActor = null
    $("form.errorcheck button[type=submit]").click(function () {
        $submitActor = $(this)
    })

    $("form.errorcheck").submit(function (event) {
        var $required = $(this).find('input, textarea, select').filter('.required')
        $required.trigger('errorcheck')
        if ($required.filter('.error').length && $submitActor && $submitActor.attr('name') != 'cancel') {
            $(this).removeClass('haserror')
            var $form = $(this)
            window.setTimeout(function () {
                $form.addClass('haserror')
            })

            event.preventDefault()
        }
        $submitActor = null
    })

    $('.errorcheck').find('input, textarea, select').filter('.required').on('errorcheck', function () {
        $(this).removeClass('error')
        if (!$(this).val()) $(this).addClass('error')
        if ($(this).val() == '0' && $(this).hasClass('gt0')) $(this).addClass('error')
    }).on('blur', function () {
        $(this).trigger('errorcheck')
    })

    $('.errorcheck').find('.emailcheckunique').on('blur', function () {
        var $field = $(this)
        $field.next('.message').slideUp(function () {
            $(this).remove()
        })
        $.ajax({
            success: function (ret) {
                if (ret == 0) {
                    $field.addClass('ok')
                } else if (ret == 1) {
                    $field.after(
                        $('<span class="message" />')
                            .html('This email address is already in use. If you have forgotten your password, please <a href="/forgot">reset it here</a>.')
                            .hide()
                    )
                    $field.addClass('error')
                } else {
                    $field.after(
                        $('<span class="message" />')
                            .html('Please enter a valid email address.')
                            .hide()
                    )
                    $field.addClass('error')
                }
                $field.next('.message').slideDown()
            },
            url: "/checkEmail?e=" + $field.val() + '&m=' + $('.usr_num').val()
        })
    })

    $('.jqdate').each(function () {
        var $alt = $('<input type="hidden">')
        $alt
            .attr('name', $(this).attr('name'))
            .val($(this).val())
        $(this)
            .removeAttr('name')
            .val($.datepicker.formatDate('DD, d MM yy', $.datepicker.parseDate('yy-mm-dd', $alt.val())))
            .after($alt)
            .datepicker({
                altFormat: 'yy-mm-dd',
                dateFormat: 'DD, d MM yy',
                altField: $alt,
            })
            .removeClass('jqdate')
    })

    $('tr.rowclick').click(function (event) {
        //event.preventDefault()
        var $a = $(this).find('a').first()
        location.href = $a.attr('href')
    })

    $('.mobile-admin-menu').on('click', function () {
        if ($('.side-nav').hasClass('mobile-menu')) {
            $('.side-nav').removeClass('mobile-menu');
        } else {
            $('.side-nav').addClass('mobile-menu');
        }

    });
}

pageLoaded()

$('.textnum').keydown(function (event) {
    if (
        event.keyCode >= 65 &&
        event.keyCode <= 90 &&
        !event.metaKey &&
        !event.altKey &&
        !event.ctrlKey
    ) event.preventDefault()
})


$(window).scroll(function () {
    if ($(window).scrollTop() > $('.banner').outerHeight()) {
        $('body').addClass('menufix')
    } else {
        $('body').removeClass('menufix')
    }
}).scroll()

/* Set Datetime fields on Properties Page*/
let date = new Date();
date.setDate(1);
date.setMonth(-1);
$('#start').val(date.toISOString().substring(0, 10));
$('#end').val(new Date().toISOString().substring(0, 10));

let con_hs = $('#con_hs');
let dateSelect = $('#hsdate');
if (con_hs.is(':checked')) {
    dateSelect.show();
} else {
    dateSelect.hide();
}

con_hs.change(function () {
    if ($(this).is(':checked')) {
        dateSelect.show("fast");
        // dateSelect.prop('required',true);
    } else {
        dateSelect.val('');
        // dateSelect.prop('required',false);
        dateSelect.hide("fast");
    }
});

let mat_landlord_job = $('#mat_landlord_job');
let contactForm = $('#mat_contact_details');
if (mat_landlord_job.is(':checked')) {
    contactForm.find('input').each(function () {
        $(this).removeClass('required');
    });
    contactForm.hide();
} else {
    contactForm.show();
}

mat_landlord_job.change(function () {
    if ($(this).is(':checked')) {
        contactForm.find('input').each(function () {
            $(this).removeClass('required');
        });
        contactForm.hide("fast");
    } else {
        contactForm.show("fast");
        contactForm.find('input').each(function () {
            $(this).addClass('required');
        });
    }
});

$(window).scroll(function () {
    if ($(this).scrollTop() > 50) {
        $(".editbutton").css('visibility', 'hidden');

    } else if ($(this).scrollTop() < 50) {
        $(".editbutton").css('visibility', 'visible');
    } else {
        $(".editbutton").css('visibility', 'visible');
    }

});

// jQuery(document).ready(function ($) {
//     jQuery('.stellarnav').stellarNav({
//         theme: 'light',
//         breakpoint: 670,
//         position: 'right',
//     });
// });

function biograph(e) {
    if (e.className == 'about__slot') {
        e.className = 'about__slot bio';
    } else {
        e.className = 'about__slot';
    }
}

function changeRequestStatus(mas_num, mat_num) {
    $.ajax({
        url: "/changerequeststatus",
        method: 'post',
        data: {mas_num: mas_num, mat_num: mat_num},
        dataType: 'json',
        complete: function (data) {
            //
        }
    });
}

